import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Button,
  Select
} from '@chakra-ui/react';
import { CreateTrainsApi } from '../../../../apis/CreateMaintenance.api';
import { TrainGroupsNameType } from '../../../../apis/ApiClient';
import { CustomNumberInput } from '../../../atoms/CustomNumberInput';
import { MainteTrainsType } from '../Table/MaintenanceTrainsTable';
import { AxiosError } from 'axios';

interface props {
  isOpen: boolean;
  onClose: () => void;
  TrainGroupsDatas: TrainGroupsNameType[] | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<MainteTrainsType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetTrainNoInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { ViewInt: 4, ViewDigit: 0, ValueMin: 0, Value: '' };
  }
  return { ViewInt: 4, ViewDigit: 0, ValueMin: 0, Value: addData };
};

const TrainsCreateWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    TrainGroupsDatas,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [trainNo, setTrainNo] = useState<string | undefined>('');
  const [trainGroup, setTrainGroup] = useState(
    TrainGroupsDatas !== undefined ? TrainGroupsDatas[0].id : 1
  );

  const CreateApi = async () => {
    const response = await CreateTrainsApi({
      no: trainNo,
      train_group_id: trainGroup
    });

    if (
      response.message !== null &&
      (response.message as AxiosError).status?.toString() === '409'
    ) {
      alert('既に登録されている車号です。');
      return;
    } else if (response.success === false) {
      alert('登録に失敗しました。');
      return;
    }
    setMaintenanceDatas(response.data as MainteTrainsType[]);
    CreateOrUpdateStateSwitch();
    onClose();
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='280px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            車両作成
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>車号</Text>
              <CustomNumberInput
                CheckInfo={GetTrainNoInputCheckData('')}
                inputValue={trainNo}
                setValue={setTrainNo}
              />

              <Text mt={4}>形式</Text>
              <Select
                mt={2}
                w='20%'
                onChange={(e) => {
                  setTrainGroup(Number(e.target.value));
                }}
                value={trainGroup}
              >
                {TrainGroupsDatas?.map((data, i) => {
                  return (
                    <option key={'option' + i} value={data.id}>
                      {data.type}
                    </option>
                  );
                })}
              </Select>
            </Box>
            <Button
              mt={10}
              onClick={() => {
                CreateApi();
              }}
            >
              作成
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(TrainsCreateWindow);
